// PageHeader — a consistent header for every page.
//
// Usage:
//   <PageHeader
//     title="Damages"
//     subtitle="Track and resolve vehicle damage across your fleet"
//     icon="🔧"
//     actions={<button className="btn btn-primary">+ Report Damage</button>}
//   />

export default function PageHeader({ title, subtitle, icon, actions, children }) {
  return (
    <div className="ph">
      <div className="ph-l">
        <div className="ph-title">
          {icon && <span style={{ marginRight: 8 }}>{icon}</span>}
          {title}
        </div>
        {subtitle && <div className="ph-sub">{subtitle}</div>}
        {children}
      </div>
      {actions && <div className="ph-r">{actions}</div>}
    </div>
  );
}
